// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "version": "0.0.0",
    "date": "2026-06-08T16:56:14.076Z",
    "hash": "7fe42ddd87f7532a03d8b6f611ee8cd92bad919a"
};
/* tslint:enable */
